module.exports = __webpack_public_path__ + "f8ae906da09db498462cf99a20cf89a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/jiaoyubao2.png
// module id = 245
// module chunks = 3